import { useMutation, useQueryClient } from "@tanstack/react-query";
import { createLectureQuizOptions as createLectureQuizOptionsApi } from "../../../../services/dashboard/apiQuizes";
import toast from "react-hot-toast";

export function useCreateQuizOptions() {
  const queryClient = useQueryClient();

  const {
    mutate: createQuizOptions,
    isPending: isCreating,
    error,
  } = useMutation({
    mutationFn: createLectureQuizOptionsApi,
    onSuccess: () => {
      toast.success("تم إضافة أختيار بنجاح");
      queryClient.invalidateQueries({
        queryKey: ["quizOptionsDB"],
      });
    },

    onError: (error) => {
      toast.error(error.response.data.message);
    },
  });

  return { createQuizOptions, isCreating, error };
}
